import { Typography } from '@design-system/components/typography/typography';
import { Checkbox } from '@design-system/components/checkbox/checkbox';
import { OtpBundlesVMData } from '../viewModel/otpBundles.viewModel';

export const FeaturesSection = ({
  features,
  disabled,
}: {
  features: OtpBundlesVMData['formData']['data']['features'];
  disabled: boolean;
}) => (
  <div className="flex flex-col gap-4">
    <Typography variant="body" size="large" color={disabled ? 'N-60' : 'B-100'}>
      Features
    </Typography>
    <div className="flex flex-col md:flex-row gap-6 px-4">
      {features.map((f) => (
        <Checkbox
          key={f.id}
          label={f.name}
          checkboxVariant="neutral"
          checked={f.checked}
          onChange={f.onChange}
          disabled={disabled}
        />
      ))}
    </div>
  </div>
);
